"use client"

import Link from "next/link"

interface FooterProps {
  siteName: string
}

export function Footer({ siteName }: FooterProps) {
  const year = new Date().getUTCFullYear();

  return (
    <footer className="py-6 md:py-0 mt-8">
      <div className="container mx-auto flex flex-col items-center justify-center gap-1 md:h-24">
        <p className="text-center text-lg leading-loose text-muted-foreground font-heading tracking-wider uppercase">
          Copyright &copy; {year} ALL RIGHTS RESERVED. {siteName}.
        </p>
        <div className="flex items-center gap-1 text-sm text-muted-foreground">
          <Link
            href="/privacy"
            prefetch={false}
            className="hover:text-foreground transition-colors underline-offset-4 hover:underline"
          >
            Privacy & Cookies
          </Link>
          <span className="text-muted-foreground/50">|</span>
          <Link
            href="/policies"
            prefetch={false}
            className="hover:text-foreground transition-colors underline-offset-4 hover:underline"
          >
            Policies
          </Link>
          <span className="text-muted-foreground/50">|</span>
          <Link
            href="/support"
            prefetch={false}
            className="hover:text-foreground transition-colors underline-offset-4 hover:underline"
          >
            Store Help
          </Link>
          <span className="text-muted-foreground/50">|</span>
          <button
            className="hover:text-foreground transition-colors underline-offset-4 hover:underline"
            onClick={() => {
              try {
                localStorage.removeItem('cookie-consent');
                window.location.reload();
              } catch { }
            }}
          >
            Manage Cookies
          </button>
        </div>
      </div>
    </footer>
  );
}
